import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useIsEventSoon } from "./useIsEventSoon";
import { usePreSparkState } from "./usePreSparkState";

/**
 * "Spark before you go" on an event page: whether to offer the event's
 * pre-event deck (the viewer holds a seat and anyone is left for them to
 * see), and whether the event is close enough that the check-in code comes
 * first. The event page unmounts while the deck is open, so coming back from
 * it asks again.
 */
export const useEventPreSpark = (
  sparkId: number | undefined,
  startsAt: string | undefined,
  registered: boolean
) => {
  const navigate = useNavigate();
  const eventSoon = useIsEventSoon(startsAt);
  const preSpark = usePreSparkState(registered ? sparkId : undefined);
  const startSparking = useCallback(
    () => navigate(`/event/${sparkId}/spark`),
    [navigate, sparkId]
  );
  return {
    eventSoon,
    preSpark,
    showPreSpark: preSpark === "available",
    startSparking,
  };
};
